import axios from 'axios';

import { ELEVATION_SERVER } from '../constant/constants';

type OPEN_ELEVATION = {
  latitude: number;
  longitude: number;
  elevation?: number;
  error?: string;
};

export const getElevation = async (lon: number, lat: number) => {
  if (ELEVATION_SERVER) {
    const res = await axios.get<OPEN_ELEVATION[]>(
      `${ELEVATION_SERVER}/api/v1/lookup`,
      {
        params: {
          locations: `${lon},${lat}`,
        },
      },
    );
    if (res.data[0]) {
      if (typeof res.data[0].elevation === 'number') {
        return res.data[0].elevation;
      }
    }
    return 0;
  }
  return 0;
};
